import i18n from "./i18n";

export const Singleton = (function () {
    let instance;

    function createInstance() {
        const object = new Object();
        return object;
    }

    return {
        getInstance: function () {
            if (!instance) {
                instance = createInstance();
            }
            return instance;
        }
    };
})();

export function IsNotPopulated(target){
    return target === null || target === undefined || target.toString().length === 0;
}
export function IsArrayNotPopulated(target){
  return target === null || target === undefined || target.length === 0;
}
export function safeClone(object){
    return JSON.parse(JSON.stringify(object));
}

export function buildDefaultOption(idValue, nameValue) {
    return [{ id: idValue, name: nameValue }];
}

export function getValueFromObject(obj, fullyQualifiedPropertyName) {
    if (typeof obj === "undefined") {
        return null;
    }

    const _index = fullyQualifiedPropertyName.indexOf(".");
    if (_index > -1) {
        return this.getValueFromObject(
            obj[fullyQualifiedPropertyName.substring(0, _index)],
            fullyQualifiedPropertyName.substr(_index + 1)
        );
    }

    return obj[fullyQualifiedPropertyName];
}

export function setValueToObject(obj, fullyQualifiedPropertyName, newValue) {
    if (typeof obj === "undefined") {
        return;
    }

    const _index = fullyQualifiedPropertyName.indexOf(".");
    if (_index > -1) {
        this.setValueToObject(
            obj[fullyQualifiedPropertyName.substring(0, _index)],
            fullyQualifiedPropertyName.substr(_index + 1),
            newValue
        );
    }

    obj[fullyQualifiedPropertyName] = newValue;
}

export function forceCorrectDate(event, object, targetKey) {
    // this is required because of a bug in IE setting two-digit years in the 190os
    // our datepicker hasn't handled this; we can remove if we change datepickers or IE fixes
    if (!event) return;
    const inputDate = new Date(event);
    let year = inputDate.getUTCFullYear();
    if (1900 <= year && year <= 1999) {
        year += 100;
    } else {
        return;
    };
    const month = inputDate.getUTCMonth();
    const day = inputDate.getUTCDate();
    const correctedDate = new Date(Date.UTC(year, month, day));
    object[targetKey] = correctedDate;
}

export function setInitialRenewalDate(selectedEffectiveDate, object, targetKey) {
    forceCorrectDate(selectedEffectiveDate, object, targetKey);
    const { effectiveDate } = object;
    if (!effectiveDate) return;
    // using UTC here to match datepickers
    const day = effectiveDate.getUTCDate();
    const month = effectiveDate.getUTCMonth();
    const year = effectiveDate.getUTCFullYear();
    const projectedRenewalDate = new Date(Date.UTC(year + 1, month, day));
    object.renewalDate = projectedRenewalDate;
}

export function setInitialExpirationDate(selectedEffectiveDate, object, targetKey) {
    forceCorrectDate(selectedEffectiveDate, object, targetKey);
    const { effectiveDate } = object;
    if (!effectiveDate) return;
    // using UTC here to match datepickers
    const day = effectiveDate.getUTCDate();
    const month = effectiveDate.getUTCMonth();
    const year = effectiveDate.getUTCFullYear();
    const projectedExpirationDate = new Date(Date.UTC(year + 1, month, day));
    object.expirationDate = projectedExpirationDate;
}

export function parsePercent(value) {
    if (i18n.locale == "fr")
        value = value.replace(",", ".");
    return value.replace("%", "");
}

export const isNullOrWhitespace = (input) => {
    return !input || !input.trim();
}

export function isBadSearchTerm(term) {
    if (isNullOrWhitespace(term))
    return true;

    if (term.trim().length < 2) //user must enter at least 2 valuable characters
        return true;

    //this is to handle strings like " ,..*.,,   .-. " but should not reject "*X, Inc." so if anythig left it's ok term
    var anythingBesidesUseless = term.replace(",", '')
        .replace(".", '')
        .replace("*", '')
        .replace("-", '')
        .replace(" ", '');

    return isNullOrWhitespace(anythingBesidesUseless);
}
